import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13 4C12.4477 4 12 4.44772 12 5V6H4C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H12V11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H12V16H4C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18H12V19C12 19.5523 12.4477 20 13 20C13.5523 20 14 19.5523 14 19V17V12V7V5C14 4.44772 13.5523 4 13 4ZM18 6C17.4477 6 17 6.44772 17 7C17 7.55228 17.4477 8 18 8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H18ZM18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H18ZM18 16C17.4477 16 17 16.4477 17 17C17 17.5523 17.4477 18 18 18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H18Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.5 2.93506C9.81204 2.93506 10.065 3.18802 10.065 3.50006V11.5001C10.065 11.8121 9.81204 12.0651 9.5 12.0651C9.18796 12.0651 8.935 11.8121 8.935 11.5001V11.0651H3.5C3.18796 11.0651 2.935 10.8121 2.935 10.5001C2.935 10.188 3.18796 9.93506 3.5 9.93506H8.935V8.06506H3.5C3.18796 8.06506 2.935 7.8121 2.935 7.50006C2.935 7.18802 3.18796 6.93506 3.5 6.93506H8.935V5.06506H3.5C3.18796 5.06506 2.935 4.8121 2.935 4.50006C2.935 4.18802 3.18796 3.93506 3.5 3.93506H8.935V3.50006C8.935 3.18802 9.18796 2.93506 9.5 2.93506ZM11.935 4.50006C11.935 4.18802 12.188 3.93506 12.5 3.93506H13.5C13.812 3.93506 14.065 4.18802 14.065 4.50006C14.065 4.8121 13.812 5.06506 13.5 5.06506H12.5C12.188 5.06506 11.935 4.8121 11.935 4.50006ZM11.935 7.50006C11.935 7.18802 12.188 6.93506 12.5 6.93506H13.5C13.812 6.93506 14.065 7.18802 14.065 7.50006C14.065 7.8121 13.812 8.06506 13.5 8.06506H12.5C12.188 8.06506 11.935 7.8121 11.935 7.50006ZM11.935 10.5001C11.935 10.188 12.188 9.93506 12.5 9.93506H13.5C13.812 9.93506 14.065 10.188 14.065 10.5001C14.065 10.8121 13.812 11.0651 13.5 11.0651H12.5C12.188 11.0651 11.935 10.8121 11.935 10.5001Z"
  />
);

export const WrapOffIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="WrapOff" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
